import styled from "styled-components";

const BaseWrap = styled.div`
    position: absolute;
    top: 0;
    left: calc(100% + 20px);
    width: min(200px, 50vw);
    height: max-content;
    border-radius: 8px;
    box-shadow:
            0px 32px 32px 0px var(--shadow-soft, rgba(88, 93, 105, 0.05)),
            0px 0px 32px 0px var(--shadow-muted, rgba(88, 93, 105, 0.1));
    background: var(--bg-surface1, #fff);
    padding: 8px;
    z-index: 10;

    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const AnimatedWrap = styled(BaseWrap)`
    &.hud-slide-enter {
        opacity: 0;
        transform: translateX(-12px);
    }
    &.hud-slide-enter-active {
        opacity: 1;
        transform: translateX(0);
        transition: opacity 200ms ease, transform 200ms ease;
    }
    &.hud-slide-exit {
        opacity: 1;
        transform: translateX(0);
    }
    &.hud-slide-exit-active {
        opacity: 0;
        transform: translateX(-12px);
        transition: opacity 150ms ease, transform 150ms ease;
    }
`;
